@let loading = this.loading();
@let taskCounts = this.taskCounts();

<ng-container *transloco="let t; scope: 'task-count'">
  @if (error()) {
    <p class="text-danger">
      {{ t('taskCount.error') }}
    </p>
  } @else {
    <div class="parent-grid">
      <div>
        <div class="title label-medium">{{ t('taskCount.today') }}</div>
        <div class="grid">
          <lyceo-statistic-card
            [title]="t('taskCount.tasks')"
            titlePlacement="bottom"
            [button]="true"
            [loading]="loading"
            [value]="taskCounts?.subTasksToday"
            (click)="taskCountClicked(TaskCountType.SUBTASKS_TODAY)"
          >
            <div slot="icon" class="stat-icon subtask-today-icon">
              <fa-icon [icon]="faNetworkWired" />
            </div>
          </lyceo-statistic-card>
          <lyceo-statistic-card
            [title]="t('taskCount.done')"
            titlePlacement="bottom"
            [button]="true"
            [loading]="loading"
            [value]="taskCounts?.tasksDoneToday"
            (click)="taskCountClicked(TaskCountType.TASKS_DONE_TODAY)"
          >
            <div slot="icon" class="stat-icon done-icon">
              <fa-icon [icon]="faCheck" />
            </div>
          </lyceo-statistic-card>
        </div>
      </div>
      <div>
        <div class="title label-medium">{{ t('taskCount.later') }}</div>
        <div class="grid">
          <lyceo-statistic-card
            [title]="t('taskCount.to_plan')"
            titlePlacement="bottom"
            [button]="true"
            [loading]="loading"
            [value]="taskCounts.tasksToPlan"
            (click)="taskCountClicked(TaskCountType.TASKS_TO_PLAN)"
          >
            <div slot="icon" class="stat-icon plan-icon">
              <fa-icon [icon]="faExclamation" />
            </div>
          </lyceo-statistic-card>
          <lyceo-statistic-card
            [title]="t('taskCount.deadlines')"
            titlePlacement="bottom"
            [button]="true"
            [loading]="loading"
            [value]="taskCounts.parentTasksUpcoming"
            (click)="taskCountClicked(TaskCountType.PARENT_TASKS_UPCOMING)"
          >
            <div slot="icon" class="stat-icon deadline-icon">
              <fa-icon [icon]="faCalendarExclamation" />
            </div>
          </lyceo-statistic-card>
        </div>
      </div>
    </div>
  }
</ng-container>
